
<div class="events">

  <div *ngIf='session.isLoggedIn$ | async' style="margin-bottom: 20px;">
    <button mat-raised-button color="secondary"
            (click)="openCategoryDialogDialog()">{{ 'Add New Info' | translate }}</button>
  </div>


  <div *ngIf="errorMessage" class="alert alert-danger">
    {{ errorMessage }}
  </div>


  <div *ngIf="isLoading" class="loading-icon">
    <mat-spinner diameter="30"></mat-spinner>
  </div>



  <div class="container-min">
    <div class="h1Container no-select">
      <h1 class="title">{{ 'Events / Infos' | translate }}</h1>
    </div>
  </div>

  <div *ngIf="!isLoading && !currentEvent && events.length === 0 && !isLoading" class="alert alert-info">
    {{ 'No data available' | translate }}
  </div>

  <div *ngIf="currentEvent" class="container-min">

    <div class="back-to-home">
      <a class="event-item-min" routerLink="/infos">
        <h3>← {{ 'Back' | translate }}</h3>
      </a>
    </div>

    <ul>
      <li class="event-item">

        <h4>{{ currentEvent.title }}</h4>
        <div class="content-event">
          <div class="event-image">
            <img *ngIf="currentEvent.smallImageUrl" [src]="currentEvent.smallImageUrl" alt="{{ currentEvent.title }}"/>
            <div *ngIf="isFullscreen" class="zoom-container fullscreen-modal" (click)="closeFullscreen()">
              <div class="fullscreen-image-container">
                <img [src]="currentImage"
                     [style.width.px]="imageWidth"
                     [style.height.px]="imageHeight"
                     class="fullscreen-image"/>
              </div>
            </div>
          </div>
          <div class="event-content">
            <p class="date">{{ formatEventDate(currentEvent.date) }}</p>
            <p class="desc">{{ currentEvent.short_description }}</p>

            <div *ngIf='session.isLoggedIn$ | async' style="margin-bottom: 20px;">
              <button mat-raised-button color="secondary"
                      (click)="openCategoryDialogDialog(currentEvent.id)">{{ 'Edit' | translate }}</button>
            </div>
          </div>
        </div>
      </li>
    </ul>

  </div>

  <div *ngIf="!currentEvent && events.length > 0" class="container-min events-list">


    <ul>
      <li *ngFor="let event of events" class="event-item">
        <div class="content-event">

          <a [routerLink]="['/infos', event.id]" class="event-image">
            <img *ngIf="event.smallImageUrl" [src]="event.smallImageUrl" alt="{{ event.title }}"/>
          </a>
          <div class="event-content">
            <h3>{{ event.title }}</h3>
            <p class="date">{{ formatEventDate(event.date) }}</p>

            <div *ngIf='session.isLoggedIn$ | async' style="margin-bottom: 20px;">
              <button mat-raised-button color="secondary"
                      (click)="openCategoryDialogDialog(event.id)">{{ 'Edit' | translate }}</button>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>

</div>


<app-app-copyright></app-app-copyright>
